import { takeEvery, select, call, put } from 'redux-saga/effects'
import {
  SOURCING_EVENT_LIST_SEARCH,
  SOURCING_EVENT_LIST_ALL_STATUS,
  SOURCING_EVENT_LIST_ALL_SEAL_STATUS,
  SOURCING_EVENT_LIST_ALL_AWARD,
  SOURCING_EVENT_LIST_ALL_USER,
} from '../constants'
const getEventListFilter = state => state.setSourcingEventListFilter
function* handleEventList() {
  yield select(getEventListFilter)
}
export function* watchEventListRfq() {
  yield takeEvery(SOURCING_EVENT_LIST_SEARCH, handleEventList)
  yield takeEvery(SOURCING_EVENT_LIST_ALL_STATUS, handleEventList)
  yield takeEvery(SOURCING_EVENT_LIST_ALL_SEAL_STATUS, handleEventList)
}
